import {Component} from '@angular/core';
import {RealTimePopupComponent} from '../../../real-time/real-time/real-time-popup/real-time-popup.component';

@Component({
    selector: 'app-traffics-intensity-popup',
    templateUrl: './traffics-intensity-popup.component.html',
    styleUrls: ['./traffics-intensity-popup.component.scss',
        '../../../real-time/real-time/real-time-popup/real-time-popup.component.scss']
})
export class TrafficIntensityPopupComponent extends RealTimePopupComponent {

}



// WEBPACK FOOTER //
// ./src/app/cities/informo/traffics-intensity-popup/traffics-intensity-popup.component.ts